import type { ExternalDeploymentEvidence } from '@lixionary-jira/domain';
import { Markdown } from '../../ui/Markdown';
import { KeyValue } from '../../ui/misc';
import { Timestamp } from '../../ui/Timestamp';

export function ExternalEvidence({ evidence: e }: { evidence: ExternalDeploymentEvidence }) {
  return (
    <div className="stack sm">
      <KeyValue
        items={[
          ['Deployed revision', <span className="mono">{e.sourceRevision}</span>],
          ['Reported deployer', e.deployedBy],
          ['Deployment time', <Timestamp value={e.deployedAt} />],
          ['Reported artifact', e.artifactDigest || 'Source revision binding'],
          ['Execution reference', e.deploymentReference || 'See deployment log'],
        ]}
      />
      <span className="small strong">Current environment observation</span>
      <Markdown>{e.environmentObservation}</Markdown>
      {e.log && (
        <>
          <span className="small strong">Deployment log</span>
          <pre className="small" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
            {e.log}
          </pre>
        </>
      )}
      <ul className="checklist">
        {e.checks.map((c) => (
          <li key={c.name}>
            {c.name}: {c.passed ? 'Passed' : 'Failed'} — {c.observation}
          </li>
        ))}
      </ul>
      {e.evidenceRefs.length > 0 && (
        <ul>
          {e.evidenceRefs.map((ref) => (
            <li key={ref}>{ref}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
